//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        answered_questions: Array
    },
    methods: {
        removeOpt(i) {
            this.$emit('removeOpt', i)
        }
    }
}
